import React from 'react';

export function ProjectCostsContractInfo() {
  const info = [
    { label: 'Tổng giá trị hợp đồng', value: '28.650.000.000 VND' },
    { label: 'Giá trị đã thanh toán', value: '13.250.000.000 VND', sub: '( 46.2% )' },
    { label: 'Giá trị còn lại', value: '15.400.000.000 VND' },
    { label: 'Hình thức hợp đồng', value: 'Trọn gói' },
    { label: 'Điều khoản thanh toán', value: 'Theo tiến độ nghiệm thu' },
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <h3 className="text-sm font-normal text-slate-900 border-b border-slate-50 pb-2">Thông tin hợp đồng</h3>
      <div className="space-y-3">
        {info.map((item, idx) => (
          <div key={idx} className="flex justify-between items-start gap-4">
             <span className="text-xs font-normal text-slate-400 whitespace-nowrap">{item.label}</span>
             <div className="text-right">
                <p className="text-xs font-normal text-slate-700">{item.value}</p>
                {item.sub && <p className="text-xs font-normal text-emerald-600">{item.sub}</p>}
             </div>
          </div>
        ))}
      </div>
    </div>
  );
}
